// Libs
import { createSlice } from '@reduxjs/toolkit';
// Others
import { createTask, getDetailTask, updateTask, deleteTask, getListTask } from './taskThunk';

export interface ITaskState {
  isRefreshTaskList: boolean;
}

export const initialState: ITaskState = {
  isRefreshTaskList: false,
};

const taskSlice = createSlice({
  name: 'task',
  initialState,
  reducers: {
    setRefreshTaskList(state, action) {
      state.isRefreshTaskList = action.payload;
    },
  },
  extraReducers(builder) {
    // GET: Get list task
    builder
      .addCase(getListTask.pending, (_state) => {})
      .addCase(getListTask.fulfilled, (_state) => {})
      .addCase(getListTask.rejected, (_state) => {});

    // POST: Create task
    builder
      .addCase(createTask.pending, (_state) => {})
      .addCase(createTask.fulfilled, (_state) => {})
      .addCase(createTask.rejected, (_state) => {});

    // GET: Detail task
    builder
      .addCase(getDetailTask.pending, (_state) => {})
      .addCase(getDetailTask.fulfilled, (_state) => {})
      .addCase(getDetailTask.rejected, (_state) => {});

    // PUT: Update task
    builder
      .addCase(updateTask.pending, (_state) => {})
      .addCase(updateTask.fulfilled, (_state) => {})
      .addCase(updateTask.rejected, (_state) => {});

    // DELETE: Delete task
    builder
      .addCase(deleteTask.pending, (_state) => {})
      .addCase(deleteTask.fulfilled, (_state) => {})
      .addCase(deleteTask.rejected, (_state) => {});
  },
});

// Action
export const taskActions = taskSlice.actions;

// Selectors

// Reducer
const taskReducer = taskSlice.reducer;
export default taskReducer;
